function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.7246 14.6016L15.9996 0L0.275103 14.6016C0.0536007 14.8078 0.0404422 15.1548 0.246593 15.3769C0.451647 15.5984 0.799801 15.611 1.0213 15.4054L2.84102 13.7156V32H11.6134H20.3858H29.1582V13.7151L30.9779 15.4048C31.0832 15.503 31.2175 15.5512 31.3513 15.5512C31.4987 15.5512 31.6451 15.4926 31.7526 15.3763C31.9593 15.1548 31.9461 14.8078 31.7246 14.6016ZM12.71 30.9035V22.1311C12.71 20.3168 14.1854 18.8414 15.9996 18.8414C17.8138 18.8414 19.2892 20.3168 19.2892 22.1311V30.9035H12.71ZM28.0616 30.9035H20.3858V22.1311C20.3858 19.7126 18.418 17.7449 15.9996 17.7449C13.5812 17.7449 11.6134 19.7126 11.6134 22.1311V30.9035H3.93757V12.6969L15.9996 1.49624L28.0616 12.6969V30.9035Z"
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "white",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.c8c677cd.svg";
export { ForwardRef as ReactComponent };